<template>
  <SectionContainer
    v-if="isLoading || courses.length"
    class="fluid-x"
  >
    <LoadingIcon
      v-if="isLoading"
      :is-loading="isLoading"
    />

    <div v-else>
      <SectionHeader>
        <template v-slot:title>
          <b>Cursos em andamento</b>
        </template>
      </SectionHeader>

      <HorizontalCarousel :items="courses">
        <template v-slot="{ item }">
          <CourseThumbBox
            :course="item"
          />

          <CourseProgressBar
            :percent="item.attended_percent"
            class="course-progress-bar"
          />
        </template>
      </HorizontalCarousel>
    </div>
  </SectionContainer>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import LoadingIcon from '@/components/layout/LoadingIcon'
  import SectionHeader from '@/components/layout/SectionHeader'
  import CourseThumbBox from '@/components/course/CourseThumbBox'
  import SectionContainer from '@/components/layout/SectionContainer'
  import CourseProgressBar from '@/components/course/CourseProgressBar'
  import HorizontalCarousel from '@/components/carousel/HorizontalCarousel'

  export default {
    components: {
      LoadingIcon,
      SectionHeader,
      CourseThumbBox,
      SectionContainer,
      CourseProgressBar,
      HorizontalCarousel
    },

    data: () => ({
      isLoading: true
    }),

    async mounted () {
      this.isLoading = true

      await this.fetchUserCoursesOngoing()

      this.isLoading = false
    },

    computed: {
      ...mapGetters('course', {courses: 'userCoursesOngoing'}),
    },

    methods: {
      ...mapActions('course', ['fetchUserCoursesOngoing'])
    }
  }
</script>

<style scoped lang="scss">
  .course-progress-bar {
    margin-top: 15px;
  }
</style>